import { Pill } from '@mantine/core';
import { usePillDrag } from '../../context';
import { DragHandle } from './components';
import classes from './RemovablePill.module.css';

type RemovablePillPropsType = {
  label: string;
  color?: string;
  isActive?: boolean;
  onClick?: () => void;
  onRemove: () => void;
};

export const RemovablePill: React.FC<RemovablePillPropsType> = ({
  label,
  color,
  isActive,
  onClick,
  onRemove,
}) => {
  const drag = usePillDrag();
  const isDragging = drag?.isDragging ?? false;

  return (
    <Pill
      withRemoveButton
      onRemove={onRemove}
      onClick={onClick}
      bg={color}
      aria-current={isActive ? 'true' : undefined}
      classNames={{
        root: `${classes.pillRoot} ${isDragging ? classes.dragging : ''}`,
        label: classes.pillLabel,
        remove: classes.removeButton,
      }}
      styles={{
        root: {
          ...(onClick && { cursor: 'pointer' }),
          ...(isActive && {
            outline: '2px solid var(--mantine-primary-color-filled)',
          }),
        },
      }}
    >
      <DragHandle className={classes.dragHandleReveal} />
      {label}
    </Pill>
  );
};
